/**
 * Aligne le CTA sticky sur le CTA du panneau principal (prix, libellé, mode abonnement).
 */
(function () {
  var ATTRS = ["data-with_price", "data-with_original_price", "data-is_disabled"];
  var SUBSCRIPTION_CLASS = "componentCta--productPanelSubscription";

  function syncStickyCta(panel) {
    var inPageCta = panel.querySelector('[data-id="inPagePanel"] [data-id="cta"]');
    var stickyCta = panel.querySelector(
      ".componentProductSelectionPanel__stickyPanel [data-id=\"cta\"]"
    );
    if (!inPageCta || !stickyCta) return;

    ATTRS.forEach(function (a) {
      if (inPageCta.hasAttribute(a)) {
        stickyCta.setAttribute(a, inPageCta.getAttribute(a) || "");
      } else {
        stickyCta.removeAttribute(a);
      }
    });

    if (inPageCta.classList.contains(SUBSCRIPTION_CLASS)) {
      stickyCta.classList.add(SUBSCRIPTION_CLASS);
    } else {
      stickyCta.classList.remove(SUBSCRIPTION_CLASS);
    }

    var inText = inPageCta.querySelector(".componentCta__text");
    var stText = stickyCta.querySelector(".componentCta__text");
    if (inText && stText) stText.textContent = inText.textContent;

    var inNew = inPageCta.querySelector('[data-id="newPrice"]');
    var stNew = stickyCta.querySelector('[data-id="newPrice"]');
    var inOrig = inPageCta.querySelector('[data-id="originalPrice"]');
    var stOrig = stickyCta.querySelector('[data-id="originalPrice"]');
    if (inNew && stNew) stNew.textContent = inNew.textContent;
    if (inOrig && stOrig) stOrig.textContent = inOrig.textContent;
  }

  function wirePanel(panel) {
    var inPagePanel = panel.querySelector('[data-id="inPagePanel"]');
    if (!inPagePanel) return;

    var mo = new MutationObserver(function () {
      syncStickyCta(panel);
    });
    mo.observe(inPagePanel, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS.concat(["data-is_selected", "class"]),
    });

    syncStickyCta(panel);
  }

  function init() {
    document
      .querySelectorAll('[data-component="productSelectionPanel"]')
      .forEach(function (panel) {
        if (panel.getAttribute("data-reglo-sticky-cta-sync-wired")) return;
        panel.setAttribute("data-reglo-sticky-cta-sync-wired", "1");
        wirePanel(panel);
      });
  }

  init();
  try {
    window.addEventListener("ig:ready", init);
  } catch (e) {}
})();
